import './styles/index.scss';
import App from './app';

export default App;
